<template>
  <div class="config_main_manage_background">
    <!-- 上部导航栏样式 -->
    <div class="main_topnav config_main_manage_topnav">
      <top-nav class="main_topnav">
        <top-nav-item
          class="left_item"
          @click.native="configGoPreviousPageHandle"
        >
          <img
            class="main_top_img"
            slot="topnavimg"
            src="~assets/img/topnav/zuofanhui.png"
            alt
          />
          <div slot="topimgtext">返回</div>
        </top-nav-item>

        <top-nav-item>
          <div slot="topimgtext">{{ this.$store.state.publicinfo.title }}</div>
        </top-nav-item>
        <!-- 右上角的主页返回按钮 需要判断一下当前账号是否有主机绑定 -->
        <top-nav-item
          v-if="bindHostState === 1"
          class="right_item"
          @click.native="configReturnContronBtnHandle"
        >
          <img
            class="main_top_img"
            slot="topnavimg"
            src="~assets/img/topnav/shebei_home.png"
            alt
          />
        </top-nav-item>

        <top-nav-item v-else> </top-nav-item>
      </top-nav>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
import topNav from 'components/common/topnav/topnav'
import topNavItem from 'components/common/topnav/topnavitem'

export default {
  data() {
    return {
      bindHostState: Number(sessionStorage.getItem('bindHostState')) ///需要转成数字类型的不然会出错 //绑定主机状态
    }
  },
  components: {
    topNav,
    topNavItem
  },
  methods: {
    configGoPreviousPageHandle() {
      ////配置场景进去后，左上角的返回按钮
      this.$router.go(-1)
    },
    configReturnContronBtnHandle() {
      ////配置页面的主页返回按钮被点击了
      this.$router.replace(this.$store.state.publicinfo.configReturnPath)
    }
  },
  created() {
    console.log('导航栏被创建了')
  }
}
</script>

<style></style>
